export default __webpack_public_path__ + "static/media/poketrade.ebdeb3ed.gif";